import {client as http, axiosInstance} from "@/http_client";
import async from "async";

export default {
    state: {
        enrollment: null
    },
    getters: {
        enrollment: state => state.enrollment
    },
    mutations: {},
    actions: {
        getClassicEnrollmentById({state}, id) {
            return new Promise((resolve, reject) => {
                http.get('app/enrollments/classic/' + id, {force: true}).then(response => {
                    let enrollment = response.data;
                    enrollment.isClassic = true;
                    enrollment.course = {
                        title: enrollment.name
                    }
                    state.enrollment = enrollment;
                    console.log('enrollment', enrollment);
                    resolve(enrollment);
                }).catch(err => {
                    reject(err.response);
                });
            });
        },
        getEnrollmentById({state}, id) {
            return new Promise((resolve, reject) => {

                let enrollment;

                async.series([
                    (cb) => {
                        http.get('app/enrollments/' + id, {force: true}).then(response => {
                            enrollment = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('app/courses/' + enrollment.course.id + '/applications', {force: true}).then(response => {
                            for (let i = 0; i < response.data.length; i++) {
                                const application = response.data[i];

                                // this.$set(application, 'ready', {});

                                application.ready = {
                                    log: false,
                                    confirm: false,
                                    toggle: false,
                                    charge: false
                                };
                            }
                            enrollment.course.applications = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('app/enrollments/' + enrollment.id + '/applications', {force: true}).then(response => {
                            enrollment.applications = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    if (err) {
                        console.log('err', err);
                        reject(err.response);
                        return;
                    }

                    // Create course outline /////////////////////////////////////////////////
                    enrollment.course.navigation = {
                        prev: null,
                        next: null,
                        current: null,
                        currentSection: null,
                        outline: [],
                        totalLessons: 0,
                        totalComplete: 0
                    };

                    let closed = null;
                    for (let i = 0; i < enrollment.course.outline.length; i++) {
                        const o = enrollment.course.outline[i];
                        if (o.type === 'SECTION') {
                            let section = {
                                type: 'SECTION',
                                title: o.title,
                                id: o.type_id,
                                children: [],
                                totalLessons: 0,
                                totalComplete: 0
                            };

                            if (o.description) {
                                section.children.push({
                                    section_id: o.type_id,
                                    type: 'OVERVIEW',
                                    id: o.type_id
                                });
                            }

                            for (let j = 0; j < o.components.length; j++) {
                                const component = o.components[j];
                                if (component.completed_at) component.closed = true;

                                if (closed === null && !component.closed) {
                                    component.closed = false;
                                    closed = true;
                                } else {
                                    component.closed = true;
                                }

                                let icon;
                                if (component.type === 'LESSON') {
                                    icon = component.navIcon = (component.completed_at) ? ['fad', 'fa-check-circle'] : (component.closed) ? ['fad', 'fa-times-circle'] : ['fad', 'fa-circle'];
                                } else if (component.type === 'CHECKPOINT') {
                                    icon = component.navIcon = (component.completed_at) ? ['fad', 'fa-location-check'] : (component.closed) ? ['fad', 'fa-location-xmark'] : ['fad', 'fa-location-question'];
                                } else if (component.type === 'QUIZ') {
                                    icon = component.navIcon = (component.completed_at) ? ['fak', 'fa-light-list-circle-check'] : (component.closed) ? ['fak', 'fa-light-list-circle-xmark'] : ['fak', 'fa-light-list-circle-question'];
                                }

                                let child = {
                                    section_id: o.type_id,
                                    type: 'COMPONENT',
                                    title: component.title,
                                    id: component.component_id,
                                    icon,
                                    complete: !!component.completed_at,
                                    closed: (!component.completed_at && component.closed),
                                    current: (!component.completed_at && !component.closed)
                                };

                                if (child.current) {
                                    enrollment.course.navigation.current = child;
                                    enrollment.course.navigation.currentSection = i;
                                }

                                if (child.complete) {
                                    enrollment.course.navigation.totalComplete++;
                                    section.totalComplete++;
                                }
                                section.totalLessons++;
                                enrollment.course.navigation.totalLessons++;

                                section.children.push(child);
                            }

                            enrollment.course.navigation.outline.push(section);
                        }
                    }

                    // Determine if coursework is complete ////////////////////////////////////////////////
                    enrollment.isCourseworkComplete = true;
                    for (let i = 0; i < enrollment.course.outline.length; i++) {
                        const o = enrollment.course.outline[i];
                        for (let j = 0; j < o.components.length; j++) {
                            if (o.components[j].completed_at === null) {
                                enrollment.isCourseworkComplete = false;
                                break;
                            }
                        }
                    }

                    // Determine if there are required or incomplete applications/forms /////////////////////////////////
                    enrollment.isMissingRequiredApps = false;
                    enrollment.isIncompleteApps = false;

                    for (let i = 0; i < enrollment.course.applications.length; i++) {
                        const courseApplication = enrollment.course.applications[i];

                        let enrollApplication = enrollment.applications.find(a => a.course_application_id === courseApplication.id);

                        if (!enrollment.isMissingRequiredApps && courseApplication.is_required_at_start && (!enrollApplication || !enrollApplication.completed_at)) {
                            enrollment.isMissingRequiredApps = true;
                        }

                        if (!enrollment.isIncompleteApps && (!enrollApplication || !enrollApplication.completed_at)) {
                            enrollment.isIncompleteApps = true;
                        }

                        courseApplication.isMissingRequired = ((courseApplication.is_required_at_start || courseApplication.is_required_at_end) && (!enrollApplication || !enrollApplication.completed_at));
                    }

                    // Complete, set and send back enrollment ///////////////////////////////////////////////////////////
                    state.enrollment = enrollment;
                    resolve(enrollment);
                });

            });
        },
    }
};
